import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2747">
      <div className="dark" data-id="element-2748">
        <Hero data-id="element-2749" />
      </div>
      <WhyUs data-id="element-2750" />
      <ByTheNumbers data-id="element-2751" />
      <Services data-id="element-2752" />
      <HowItWorks data-id="element-2753" />
      <FAQ data-id="element-2754" />
      <Reviews data-id="element-2755" />
      <CtaBanner data-id="element-2756" />
    </main>;
}